/**
 * Created by Ivo Mehide <ivo@degeetia.ee> on 20.05.17.
 */

import React from "react";
import PropTypes from "prop-types";
import {strvalue, stripstrvalue} from "../../../util";
import t from "../../../trans";

class Profile extends React.Component {
    static propTypes = {
        /**
         * @property {Person}
         */
        person: PropTypes.object.isRequired,
        /**
         * @property {PersonRole}
         */
        activeRole: PropTypes.object.isRequired,
        onClickSwitchRole: PropTypes.func,
        onClickProfile: PropTypes.func,
        onClickLogout: PropTypes.func
    };

    static defaultProps = {};

    constructor(props) {
        super(props);
        this.state = {};

        this.getActiveRoleName = this.getActiveRoleName.bind(this);
        this.getActiveRoleOrgName = this.getActiveRoleOrgName.bind(this);
        this.getUserName = this.getUserName.bind(this);
        this.toggleDropdown = this.toggleDropdown.bind(this);
        this.onClickSwitchRole = this.onClickSwitchRole.bind(this);
        this.onClickProfile = this.onClickProfile.bind(this);
        this.onClickLogout = this.onClickLogout.bind(this);
    }

    onClickSwitchRole(e) {
        e.preventDefault();
        if (this.props.onClickSwitchRole) this.props.onClickSwitchRole();
    }

    onClickProfile(e) {
        e.preventDefault();
        if (this.props.onClickProfile) this.props.onClickProfile();
    }

    onClickLogout(e) {
        e.preventDefault();
        if (this.props.onClickLogout) this.props.onClickLogout();
    }

    toggleDropdown(e) {
        e.preventDefault();
        this.setState({
            dropdownVisible: !this.state.dropdownVisible
        });
    }

    getUserName() {
        if (this.props.person) return stripstrvalue(this.props.person.firstName + " " + this.props.person.lastName);
        return "";
    }

    getActiveRoleOrgName() {
        let activeRole = this.props.activeRole;
        if (!activeRole || !activeRole.organization) return "";
        return activeRole.organization.name;
    }

    getActiveRoleName() {
        if (!this.props.activeRole || !this.props.activeRole.role) return "";
        return this.props.activeRole.role.name;
    }

    render() {
        return (
            <div className="nav-header">
                <div className={"dropdown profile-element"}>
                    <a data-toggle="dropdown" className="dropdown-toggle" href="#" onClick={this.toggleDropdown}>
                        <span className="clear">
                            <span className="block m-t-xs"><strong className="font-bold">{this.getUserName()}</strong> <b className="caret"></b></span>
                            <span className="text-muted text-xs block">{this.getActiveRoleOrgName()}</span>
                            <span className="text-muted text-xs block">{this.getActiveRoleName()}</span>
                        </span>
                    </a>
                    <ul className="dropdown-menu animated fadeInRight m-t-xs">
                        {
                            this.props.onClickSwitchRole ?
                                <li><a href="#" onClick={this.onClickSwitchRole}>{t("Switch role")}</a></li> :
                                null
                        }
                        {
                            this.props.onClickProfile ?
                                <li><a href="#" onClick={this.onClickProfile}>{t("Profile")}</a></li> :
                                null
                        }
                        <li className="divider"></li>
                        <li><a href="#" onClick={this.onClickLogout}>{t("Logout")}</a></li>
                    </ul>
                </div>
            </div>
        );
    }
}

export default Profile;
